module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/UserAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/users/routes/add/index.js